import {batchGetPackageSummaryForTrackingId} from "../../../../commons/api/BatchGetPackageSummaryResults";

const BATCH_SIZE = 500;

export const fetchBatchPackageSummary = async (trackingIds) => {
    const results = [];

    for (let i = 0; i < trackingIds.length; i += BATCH_SIZE) {
        const batch = trackingIds.slice(i, i + BATCH_SIZE);
        const result = await batchGetPackageSummaryForTrackingId(batch)
        results.push(result);
    }
    const combinedResults = results.flat();
    return combinedResults;

}


// WEBPACK FOOTER //
// ./src/components/detailPages/associateDetails/safetyReport/BatchPackageSummary.js